import axios from 'axios';
import { HistoryEntry, MetaUnileverColumn, MetaUnileverRow, SaveResponse } from './types';

type FetchResponse = {
  success: boolean;
  data: {
    columns: MetaUnileverColumn[];
    rows: MetaUnileverRow[];
    updated_at?: string | null;
  };
  error?: string;
};

export async function fetchMetasUnilever(): Promise<FetchResponse> {
  const { data } = await axios.get<FetchResponse>('/datatransfer/metas-unilever-legado');
  return data;
}

export async function saveMetasUnilever(
  rows: MetaUnileverRow[],
  source: 'table' | 'form' | 'import',
  action: string,
  ignoreNotFound = false
): Promise<SaveResponse> {
  try {
    const { data } = await axios.put<SaveResponse>('/datatransfer/metas-unilever-legado', {
      rows,
      source,
      action,
      ignoreNotFound,
    });
    return data;
  } catch (error: any) {
    return error?.response?.data || {
      success: false,
      error: 'Falha na comunicacao com o servidor',
    };
  }
}

type RawHistoryResponse = {
  success: boolean;
  data: Array<Omit<HistoryEntry, 'data'> & { data: string | HistoryEntry['data'] }>;
};

export async function fetchMetasUnileverHistory(): Promise<HistoryEntry[]> {
  const { data } = await axios.get<RawHistoryResponse>('/datatransfer/metas-unilever-legado/history');
  const rows = data?.data || [];

  return rows.map((entry) => {
    let parsed = {};
    try {
      parsed = typeof entry.data === 'string' ? JSON.parse(entry.data || '{}') : entry.data || {};
    } catch {
      parsed = {};
    }

    return {
      ...entry,
      data: parsed,
    } as HistoryEntry;
  });
}
